import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class FeedbackGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var feedbackGrid = this;
		setTimeout(function(){
			feedbackGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var feedbackGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',					
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Outstanding'
							}, {
								code: 'I',
								desc: 'Complete'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				},
				{
					tag: 'vaadin-button',
					itemid: 'view',
					theme: 'primary',
					disabled: true,
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('lumo:eye', ' View')
					],
					listeners: {
						click: function() {							
							actionView(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'updateStatus',
					'class': 'spacer-toolbar-item',				
					permissions: ['ADMIN_FEEDBACK_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Mark Complete/Outstanding')
					],
					listeners: {
						click: function() {							
							actionUpdateStatus(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'comments',					
					disabled: true,
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:comments', ' Comments')
					],
					listeners: {
						click: function() {							
							actionComments(grid.selectedItems[0]);
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'delete',
					theme: 'error primary',					
					permissions: ['ADMIN_FEEDBACK_MANAGEMENT:DELETE'],
					'class': 'spacer-toolbar-item',
					style: 'float: right;',					
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}			
			]
		});	
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}				
			},			
			children: [	
				{						
					path: 'updateDts',
					header: 'Update Date',					
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);	
						if (rowData.item.expirationDts) {
							var expirationDate = TimeUtil.parseDate(rowData.item.expirationDts);
							var now = new Date();
							if (expirationDate < now) {
								root.innerHTML = TimeUtil.formatDateStandard(date) + '<br><b>Expired</b>';
							} else {
								var daysLeft = Math.round(TimeUtil.daysBetween(expirationDate, now));
								root.innerHTML = TimeUtil.formatDateStandard(date) + '<br><b>Expires in ' + daysLeft + ' day(s)</b>';
							}
						} else {
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						}
					}
				},
				{						
					path: 'ticketType',
					header: 'Ticket Type',					
					width: '7em'
				},				
				{						
					path: 'summary',
					header: 'Summary',					
					width: '9em'
				},
				{						
					path: 'description',
					header: 'Description',						
					'flex-grow': '1',
					renderer: function(root, column, rowData) {
						root.innerHTML = rowData.item.description;
					}
				},
				{						
					path: 'companyName',
					header: 'Company Name',					
					width: '7em'
				},
				{						
					path: 'companyType',
					header: 'Company Type',					
					width: '7em'
				},	
				{						
					path: 'username',
					header: 'Username',					
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0 && !grid.selectedItems[0].coreModule) {						
						ElementUtil.query(toolbar, 'view').disabled = false; 
						ElementUtil.query(toolbar, 'updateStatus').disabled = false;
						ElementUtil.query(toolbar, 'comments').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'view').disabled = true;
						ElementUtil.query(toolbar, 'updateStatus').disabled = true;
						ElementUtil.query(toolbar, 'comments').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					feedbackGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						status: ElementUtil.query(toolbar, 'status').value						
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						feedbackGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					Service.getFeedbackService().getFeedback(feedbackGrid.currentFilter)
					.then(function(records){							
						successHandler(records);
					});
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});

		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				actionExport();
			}
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		feedbackGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);			
		};

		var actionExport = function() {
			var exportFilter = Object.assign({}, feedbackGrid.currentFilter || {});
			delete exportFilter.offset;
			delete exportFilter.max;
			Service.getFeedbackService().exportFeedback(exportFilter);
		};
		
		var actionView = function(record) {
			
			var viewWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'View Feedback',
				icon: 'lumo:eye',
				listeners: {
					ready: function() {
						
						viewWin.show();
						
						var getDetails = function(inputRecord) {
							
							var date = TimeUtil.parseDate(inputRecord.updateDts);						
							var formatedDate =  TimeUtil.formatDateStandard(date);
							var detailData = [
								{
									key: 'Create Date',
									value: TimeUtil.formatDateStandard(TimeUtil.parseDate(inputRecord.createDts))
								},
								{
									key: 'Update Date',
									value: formatedDate
								},
								{
									key: 'Expiration Date',
									value: (inputRecord.expirationDts ? TimeUtil.formatDateStandard(TimeUtil.parseDate(inputRecord.expirationDts)) : 'N/A')
								},
								{
									key: 'Company Id',
									value: inputRecord.companyId
								},
								{
									key: 'Company Name',
									value: inputRecord.companyName
								},
								{
									key: 'Company Type',
									value: (inputRecord.companyType ? inputRecord.companyType : '')
								},
								{
									key: 'Ticket Type',
									value: inputRecord.ticketType
								},
								{
									key: 'Summary',
									value: inputRecord.summary
								},
								{
									key: 'Description',
									value: inputRecord.description ? inputRecord.description.replace(/(?:\r\n|\r|\n)/g, '<br>') : ''
								},
								{
									key: 'Username',
									value: inputRecord.username
								},
								{
									key: 'First Name',
									value: inputRecord.firstname
								},
								{
									key: 'Last Name',
									value: inputRecord.lastname
								},
								{
									key: 'Email',
									value: inputRecord.email
								},
								{
									key: 'Phone',
									value: inputRecord.phone
								},
								{
									key: 'Web Information - Location',
									value: (inputRecord.webInformation && inputRecord.webInformation.location ? inputRecord.webInformation.location : 'N/A')
								},
								{
									key: 'Web Information - Referrer',
									value: (inputRecord.webInformation && inputRecord.webInformation.referrer ? inputRecord.webInformation.referrer : 'N/A')
								},
								{
									key: 'Web Information - Screen Resolution',
									value: (inputRecord.webInformation && inputRecord.webInformation.screenResolution ? inputRecord.webInformation.screenResolution : 'N/A')
								},
								{
									key: 'Web Information - User Agent',
									value: (inputRecord.webInformation && inputRecord.webInformation.userAgent ? inputRecord.webInformation.userAgent : 'N/A')
								}
								
							];
							return detailData;
						};
						
						var details = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								{
									tag: 'div',																		
									slot: 'primary',
									children: [
										{
											tag: 'dl-detail-table',
											itemid: 'table'									
										}
									]
								},
								{
									tag: 'dl-nextprev-toolbar',	
									itemid: 'nextPrev',
									slot: 'footer',
									listeners: {
										ready: function(event){
											event.target.updateData(feedbackGrid.fullDataSet);
											event.target.setSelectedRecord('notificationId', record.notificationId);
										},
										change: function(event) {
											grid.deselectItem(record);
											grid.selectItem(event.detail.item);
											record = event.detail.item;
											ElementUtil.query(details, 'table').updateDetails(getDetails(record));	
										}										
									}
								}
							]
						});
						viewWin.addToContentElement(details);
						ElementUtil.query(details, 'table').updateDetails(getDetails(record));						
						
					}
				}
			});
		
						
		};
		
		var actionUpdateStatus = function(record) {
			var loadMask = grid.showLoading('Updating...');	
			if (record.activeStatus === 'A') {
				Service.getFeedbackService().markAsComplete(record.feedbackId).then(function(){
					loadMask.remove();				
					actionRefresh();
				});	
			} else {
				Service.getFeedbackService().markAsOutstanding(record.feedbackId).then(function(){
					loadMask.remove();				
					actionRefresh();
				});
			}
		};
		
		var actionDelete = function(record) {
			var summary = window.DL.MessageUtil.ellipseText(record.summary, 20);
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete ' + summary + ' message?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting message...');													
							
							Service.getFeedbackService().deleteFeedback(record.feedbackId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted message: ' + summary, {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});				
		};
		
		var actionComments = function(record) {
			
			var commentWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Comments',
				icon: 'vaadin:comments',
				listeners: {
					ready: function() {						
						commentWin.show();
																	
						var commentToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'dl-action-button',									
									'class': 'spacer-toolbar-item',
									permissions: ['ADMIN_FEEDBACK_MANAGEMENT:WRITE'],
									children:[
										ElementUtil.makeIcon('vaadin:plus', ' Add')
									], 
									listeners: {
										click: function() {
											actionAddEditComment();
										}
									}
								},
								{
									tag: 'dl-action-button',	
									itemid: 'edit',
									disabled: true,
									'class': 'spacer-toolbar-item',
									permissions: ['ADMIN_FEEDBACK_MANAGEMENT:WRITE'],
									children:[
										ElementUtil.makeIcon('vaadin:edit', ' Edit')
									], 
									listeners: {
										click: function() {
											actionAddEditComment(commentsGrid.selectedItems[0]);
										}
									}
								},
								{
									tag: 'dl-action-button',											
									itemid: 'delete',
									disabled: true,
									theme: 'error primary',
									'class': 'spacer-toolbar-item',
									style: 'float: right;',
									permissions: ['ADMIN_FEEDBACK_MANAGEMENT:DELETE'],
									children:[
										ElementUtil.makeIcon('vaadin:trash', ' Delete')
									],
									listeners: {
										click: function() {
											actionDeleteComment(commentsGrid.selectedItems[0]);
										}
									}
								}			
							]
						});
						
						var commentsGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'wrap-cell-content row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',			
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},			
							children: [				
								{						
									path: 'comment',
									header: 'Comment',
									width: '12em',
									'flex-grow': '1',
									renderer: function(root, column, rowData) {	
										root.innerHTML = rowData.item.comment;
									}
								},
								{						
									path: 'updateDts',
									header: 'Update Date',
									'text-align': 'center',
									width: '7em',
									renderer: function(root, column, rowData) {										
										root.innerHTML = TimeUtil.formatDateStandard(TimeUtil.parseDate(rowData.item.updateDts));
									}
								},
								{
									path: 'updateUser',
									header: 'Update User',
									'text-align': 'center',
									width: '9em'										
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									commentsGrid.selectedItems = item ? [item] : [];
									if (commentsGrid.selectedItems.length > 0) {						
										ElementUtil.query(commentToolbar, 'edit').disabled = false;
										ElementUtil.query(commentToolbar, 'delete').disabled = false;										
									} else {
										ElementUtil.query(commentToolbar, 'edit').disabled = true;
										ElementUtil.query(commentToolbar, 'delete').disabled = true;	
									}	
								}
							}
						});						
						
						var flexLayoutComments = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								commentToolbar,
								commentsGrid
							]
						});							
						
						commentWin.addToContentElement(flexLayoutComments);						
					
						var actionRefreshComments = function() {
							var loadMask = commentsGrid.showLoading();								
							Service.getFeedbackService().getFeedbackComments(record.feedbackId).then(function(data){
								loadMask.remove();								
								commentsGrid.activeItem = null;
								commentsGrid.items = data;
							});
							
						};
						actionRefreshComments();

						var actionAddEditComment = function(commentRecord) {
							//form window
							
							var commentWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Add/Edit Comment',
								width: '0.5',
								height: '0.5',
								icon: 'vaadin:comments',
								listeners: {
									ready: function() {						
										commentWin.show();
										
										var formPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',											
											slot: 'primary',
											children: [
												{
													tag: 'vaadin-text-area',
													label: 'Comment', 
													name: 'comment',
													required: true,
													colspan: 2,
													style: 'height: calc(80% - 0rem); width: calc(99.9% - 0rem);'
												},									
												{
													tag: 'hr',
													colspan: 2
												},
												{
													tag: 'div',
													style: 'text-align: center;',
													colspan: 2,
													defaults: {
														tag: 'vaadin-button'
													},
													children: [
														{
															theme: 'primary',
															children: [
																ElementUtil.makeIcon('vaadin:database', ' Save')
															],
															listeners: {
																click: function() {

																	formPanel.submitForm({
																		actualCall: function(data) {
																			data.comment = data.comment.replace(/(?:\r\n|\r|\n)/g, '<br>');
																			data.feedbackId = record.feedbackId;
																			var edit = false;
																			if (commentRecord) {
																				edit = true;
																				data.commentId = commentRecord.commentId;
																			}

																			return Service.getFeedbackService().saveFeedbackComment(data, edit);
																		},
																		success: function(data, responseData) {
																			actionRefreshComments();
																			commentWin.close();
																			window.DL.MessageUtil.showToast('Success', 'Saved Comment', {
																				theme: 'success'
																			});	
																		}
																	});																

																}
															}
														},
														{
															theme: 'tertiary',
															innerHTML: 'Cancel',
															style: 'margin-left: 10px;',
															listeners: {
																click: function() {
																	//cancel
																	commentWin.close();
																}
															}
														}
													]
												}
											]

										});
										
										var flexLayoutCommentForm = ElementUtil.create({
											tag: 'dl-flex-layout',
											children: [
												formPanel
											]
										});
										
										commentWin.addToContentElement(flexLayoutCommentForm);			

										if (commentRecord) {
											//load form
											var copyRecord = Object.assign({}, commentRecord);
											copyRecord.comment = copyRecord.comment.replace(/<br>/g, '\n');											
											formPanel.load(copyRecord);
										}
										
									}
								}
							});
							
						};		

						var actionDeleteComment = function(commentRecord) {
							
							window.DL.MessageUtil.showConfirm({
								title: 'Confirm Delete',
								message: 'Are you sure you want to delete the selected comment?',
								buttons: [
									{
										text: 'Yes',
										handler: function() {
											var loadMask = grid.showLoading('Deleting comment...');													

											Service.getFeedbackService().deleteFeedbackComment(commentRecord.feedbackId, commentRecord.commentId).then(function(){
												loadMask.remove();
												window.DL.MessageUtil.showToast('Success', 'Deleted comment.', {									
													theme: 'success'
												});
												actionRefreshComments();
											});															

										}	
									},
									{
										text: 'No'
									}
								]
							});

						};
						
					}
				}
			});
			
		};

	}
	
};
customElements.define('dl-feedback-grid', FeedbackGrid);


